<pcc-header (showHelp)="toggleHelp()"></pcc-header>
<div id="main">
  <pcc-help id="helppanel" (closeHelp)="closeHelp()" [helpContent]="helpContent"
    [ngClass]="displayHelpPanel ? 'open' : 'closed'">
  </pcc-help>
  <pcc-sidebar *ngIf="userIsAuthenticated && !mobileDevice" id="sidebar"
    [ngClass]="displaySidebar ? 'open' : 'closed'">
  </pcc-sidebar>
  <div id="content">
    <pcc-select-supplier *ngIf="winningsUser && mobileDevice"></pcc-select-supplier>
    <router-outlet></router-outlet>
  </div>
  <div id="sidebartoggle">
    <p-avatar *ngIf="userIsAuthenticated && !mobileDevice" (click)="displaySidebar = !displaySidebar"
      [icon]="displaySidebar ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right'" shape="circle">
    </p-avatar>
  </div>
</div>